import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PlanSchema = withDefaults({
  type: 'plan',
  objectExtensions: ['plan'],
  fields: [
    {
      kind: 'attribute',
      name: 'companyKey',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'currency',
    },
    {
      kind: 'attribute',
      name: 'cadence',
    },
    {
      kind: 'attribute',
      name: 'milestoneDate',
    },
    {
      kind: 'attribute',
      name: 'waitingPeriod',
    },
    {
      kind: 'attribute',
      name: 'waitingPeriodUnit',
    },
    {
      kind: 'attribute',
      name: 'isMinMonthly',
    },
    {
      kind: 'attribute',
      name: 'stats',
    },
    {
      kind: 'attribute',
      name: 'tiers',
    },
    {
      kind: 'attribute',
      name: 'lifetimeLimit',
    },
    {
      kind: 'attribute',
      name: 'annualLimit',
    },
    {
      kind: 'attribute',
      name: 'checkObservations',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'checkParentPlusLoans',
    },
    {
      kind: 'attribute',
      name: 'fromDate',
    },
    {
      kind: 'attribute',
      name: 'day1',
    },
    {
      kind: 'attribute',
      name: 'stalenessCutoff',
    },
    {
      kind: 'hasMany',
      name: 'employees',
      type: 'employee',
      options: {
        async: false,
        inverse: 'plan',
      },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: 'plans',
      },
    },
    {
      kind: 'belongsTo',
      name: 'planAuditSchedule',
      type: 'plan-audit-schedule',
      options: {
        async: false,
        inverse: 'plan',
      },
    },
    {
      kind: 'hasMany',
      name: 'eligibilityConditions',
      type: 'eligibility-condition',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PlanSchema;
